// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__9bdeO","rootSuccess":"CompleteLink_rootSuccess__3jLln","rootFailure":"CompleteLink_rootFailure__2jCSv","isDisabled":"CompleteLink_isDisabled__yuqAk"};